
/**
 * 
 * @hidden
 */
export enum CommandParameterDirection {

    /**
     * 
     */
    Input = 0,

    /**
     * 
     */
    Output = 1,
}
